import { Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";
import { MenuItem, PrimeIcons } from "primeng/api";
import { AuthService } from "../auth/auth.service";
import { CargoFeaturesModel, ClientInfoModel } from "../model";
import { AbstractMenuModule } from "./abstract-menu-module";

@Injectable({
  providedIn: 'root'
})
export class MainMenuService {
  private menuModules: AbstractMenuModule[] = [];
  public menuItems = signal<MenuItem[]>([]);
  private cargoFeatures?: CargoFeaturesModel;

  constructor(public authService: AuthService, private router: Router) {
  }

  public addMenuModule(module: AbstractMenuModule) {
    this.menuModules.push(module);
  }

  /**
   * Build the whole menu according the cargo features and user data
   */
  public async buildMenu() {
    let user: ClientInfoModel | undefined = undefined;
    let features: CargoFeaturesModel | undefined = undefined;

    try {
      user = await this.authService.userData();
    } catch { }

    try {
      features = await this.authService.cargoFeatures();
    } catch { }

    let menuItems: MenuItem[] = [];

    this.menuModules.forEach((menu: AbstractMenuModule) => {
      if (menu.checkUserRole(this.authService?.authUser?.userRole)) {
        menuItems = [...menuItems, ...menu.buildMenu(user, this.authService.authUser!, features)]
      }
    });

    this.menuItems.set(menuItems);
  }

  public logout() {
    this.authService.logout()
      .then(res => this.router.navigate(['/']))
      .catch(err => this.router.navigate(['/']));

    this.buildMenu();
  }

  /**
  * Navigate according to the user role name
  * 
  * @param userRole 
  */
  public navigateRouting(userRole?: string) {
    switch (userRole) {
      case 'root': {
        this.router.navigate(['/rootPanel']);
        break;
      }
      case 'admin': {
        this.router.navigate(['/adminPanel/shipments']);
        break;
      }
      case 'storeman': {
        this.router.navigate(['/adminPanel/received']);
        break;
      }
      case 'storage': {
        this.router.navigate(['/storagePanel']);
        break;
      }
      case 'customer': {
        this.router.navigate(['/my-tracks']);
        break;
      }
      default: {
        this.router.navigate(['/']);
      }
    };
  }
}